import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  SELECT_PREPAYMENT_ORDER_BALANCE_AFTER_ORDER_IN_CENTS,
  SELECT_BALANCE_BEFORE_ORDER_IN_CENTS,
  SELECT_PREPAYMENT_ORDER_USER_CAN_USE_PREPAYMENT_FROM_ORDER,
  SELECT_PREPAYMENT_TOP_UP_PRESELECTED_AMOUNT_IN_CENTS,
  SELECT_PREPAYMENT_TOP_UP_PRODUCT_ID,
  SELECT_PREPAYMENT_TOP_UP_AMOUNT_MIN_IN_CENTS,
  SELECT_PREPAYMENT_TOP_UP_AMOUNT_MAX_IN_CENTS,
  SELECT_PREPAYMENT_ACTIVE_PLUGIN_TYPE,
  SELECT_PREPAYMENT_LOADING,
  SELECT_PREPAYMENT_LOADED,
  SELECT_PREPAYMENT_USER_HAS_A_BALANCE_ACCOUNT,
  SELECT_PREPAYMENT_USER_CAN_USE_PREPAYMENT_FROM_ORDER,
  SELECT_PREPAYMENT_ORDER_LOADED,
  SELECT_PREPAYMENT_ORDER_LOADING,
  SELECT_PREPAYMENT_ORDER_USER_HAS_A_BALANCE_ACCOUNT,
  SELECT_PREPAYMENT_ORDER_BALANCE_BEFORE_ORDER_IN_CENTS,
  SELECT_PREPAYMENT_ORDER_ACTIVE_SHOP_ID,
  SELECT_PREPAYMENT_PLUGIN_TYPE_BY_SHOP,
} from '@store/prepayment/prepayment.selection';

@Injectable({ providedIn: 'root' })
export class PrepaymentSelectorService {
  private readonly store = inject(Store);
  // todo pass shopId where needed 👇
  public readonly selectBalanceBeforeOrderInCents = (shopId: string) =>
    this.store.selectSignal(SELECT_BALANCE_BEFORE_ORDER_IN_CENTS(shopId));

  public readonly selectOrderBalanceBeforeOrderInCents = this.store.selectSignal(
    SELECT_PREPAYMENT_ORDER_BALANCE_BEFORE_ORDER_IN_CENTS,
  );

  /**
   * Use it on order related components only
   */
  public readonly selectOrderBalanceAfterOrderInCents = this.store.selectSignal(
    SELECT_PREPAYMENT_ORDER_BALANCE_AFTER_ORDER_IN_CENTS,
  );

  /**
   * Use it on order related components only
   */
  public readonly selectOrderUserCanUsePrepayment = this.store.selectSignal(
    SELECT_PREPAYMENT_ORDER_USER_CAN_USE_PREPAYMENT_FROM_ORDER,
  );

  public readonly selectUserCanUsePrepayment = (shopId: string) =>
    this.store.selectSignal(SELECT_PREPAYMENT_USER_CAN_USE_PREPAYMENT_FROM_ORDER(shopId));

  public readonly selectTopUpPreselectedAmountInCents = this.store.selectSignal(
    SELECT_PREPAYMENT_TOP_UP_PRESELECTED_AMOUNT_IN_CENTS,
  );

  public readonly selectTopUpProductId = this.store.selectSignal(
    SELECT_PREPAYMENT_TOP_UP_PRODUCT_ID,
  );

  public readonly selectTopUpAmountMinInCents = this.store.selectSignal(
    SELECT_PREPAYMENT_TOP_UP_AMOUNT_MIN_IN_CENTS,
  );

  public readonly selectTopUpAmountMaxInCents = this.store.selectSignal(
    SELECT_PREPAYMENT_TOP_UP_AMOUNT_MAX_IN_CENTS,
  );

  public readonly selectPrepaymentActivePluginType = this.store.selectSignal(
    SELECT_PREPAYMENT_ACTIVE_PLUGIN_TYPE,
  );

  public readonly selectPrepaymentActivePluginType$ = this.store.select(
    SELECT_PREPAYMENT_ACTIVE_PLUGIN_TYPE,
  );

  public readonly selectPrepaymentPluginTypeByShop = (shopId: string) =>
    this.store.selectSignal(SELECT_PREPAYMENT_PLUGIN_TYPE_BY_SHOP(shopId));

  public readonly selectPrepaymentPluginTypeByShop$ = (shopId: string) =>
    this.store.select(SELECT_PREPAYMENT_PLUGIN_TYPE_BY_SHOP(shopId));

  public readonly selectUserHasABalanceAccount = (shopId: string) =>
    this.store.selectSignal(SELECT_PREPAYMENT_USER_HAS_A_BALANCE_ACCOUNT(shopId));

  public readonly selectOrderUserHasABalanceAccount = this.store.selectSignal(
    SELECT_PREPAYMENT_ORDER_USER_HAS_A_BALANCE_ACCOUNT,
  );

  public readonly selectOrderActiveShopId = this.store.selectSignal(
    SELECT_PREPAYMENT_ORDER_ACTIVE_SHOP_ID,
  );

  public readonly selectUserBalanceLoading$ = (shopId: string) =>
    this.store.select(SELECT_PREPAYMENT_LOADING(shopId));

  public readonly selectOrderUserBalanceLoading = this.store.selectSignal(
    SELECT_PREPAYMENT_ORDER_LOADING,
  );
  public readonly selectUserBalanceLoaded = (shopId: string) =>
    this.store.selectSignal(SELECT_PREPAYMENT_LOADED(shopId));
  public readonly selectOrderUserBalanceLoaded = this.store.selectSignal(
    SELECT_PREPAYMENT_ORDER_LOADED,
  );
}
